/** React */
import { useState } from "react";
import moment from "moment";

/** MUI icons */
import DeleteIcon from "@mui/icons-material/Delete";

/** MUI */
import { Grid, MenuItem } from "@mui/material";

/** Components */
import { useGlobalContext } from "../../../context/GlobalContext";
import BaseSelect2 from "../../ui/BaseSelect2";
import CustomDatePicker from "../../ui/CustomDatePicker";
import FiltersPopover from "../../ui/FiltersPopover";

const FiltersButtonDet = (props) => {
    const { filters, setFilters, setRowsDet, rowsDetOG, filterByStatus, conversionData, setPage } = props;

    const { t } = useGlobalContext();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    /* Filtraríamos por Banco (cuenta bancaria), fecha de carga (campo desde y hasta), formato, fecha de estados de cuenta (fecha desde y hasta), usuario y estatus.*/

    const attributes = [
        { id: 1, name: t("converter.adjusTran"), query: "transactions" },
        { id: 2, name: t("payment.date"), query: "dates" },
    ];

    const trans = [
        { id: 1, name: t("converter.missingInfo") },
        { id: 2, name: t("converter.invalidDates") },
        { id: 3, name: t("converter.revenue") },
        { id: 4, name: t("converter.egress") },
        { id: 5, name: t("converter.duplicated") },
    ];

    const addFilter = () => {
        if (filters.filtersArray.length <= 2) {
            setFilters({
                ...filters,
                filtersArray: [
                    ...filters.filtersArray,
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                    },
                ],
            });
        }
    };

    const filterByDate = (value, arr) => {
        let newRows = [];
        if (value.since && value.until) {
            newRows = arr.filter(
                (item) => item.date.isSameOrAfter(value.since) && item.date.isSameOrBefore(value.until)
            );
        } else {
            if (value.since) {
                newRows = arr.filter((item) => item.date.isSameOrAfter(value.since));
            }
            if (value.until) {
                newRows = arr.filter((item) => item.date.isSameOrBefore(value.until));
            }
        }
        return newRows;
    };

    const removeFilter = (index) => {
        const array = [...filters.filtersArray];

        if (index !== -1) {
            array.splice(index, 1);
            setFilters({
                ...filters,
                filtersArray: array,
            });

            let newRows = [];

            if (array[0].type === 1) {
                newRows = filterByStatus(array[0].value, rowsDetOG);
            } else {
                newRows = filterByDate(array[0], rowsDetOG);
            }

            setPage(0);
            setRowsDet(newRows);
        }
    };

    const removeFirstFilter = () => {
        setPage(0);
        setRowsDet(rowsDetOG);

        setFilters({
            filtersArray: [
                {
                    type: "",
                    value: "",
                    since: "",
                    until: "",
                },
            ],
        });
    };

    const handleChangeType = (event, index) => {
        const aux = [...filters.filtersArray];
        aux[index].type = event.target.value;
        aux[index].value = "";
        aux[index].since = conversionData.initial_date ? moment(conversionData.initial_date) : null;
        aux[index].until = conversionData.end_date ? moment(conversionData.end_date) : null;

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const handleChangeFilter = (event, index) => {
        const aux = [...filters.filtersArray];

        aux[index].value = event.target.value;
        aux[index].since = "";
        aux[index].until = "";
        let rowsFiltered = [...rowsDetOG];

        // Si exite otro filtro, lo aplica primero
        const transFilter = aux.find((item) => item.since || item.until);

        if (transFilter) {
            rowsFiltered = filterByDate(transFilter, rowsDetOG);
        }

        const newRows = filterByStatus(event.target.value, rowsFiltered);

        setPage(0);
        setRowsDet(newRows);

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const handleChangeFilterRange = (event, index, range) => {
        let aux = [...filters.filtersArray];
        aux[index][range] = event;
        aux[index].value = "";
        let rowsFiltered = [...rowsDetOG];

        // Si exite otro filtro, lo aplica primero
        const transFilter = aux.find((item) => item.value);

        if (transFilter) {
            rowsFiltered = filterByStatus(transFilter.value, rowsDetOG);
        }

        const newRows = filterByDate(aux[index], rowsFiltered);

        setPage(0);
        setRowsDet(newRows);

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const cleanFilters = (e) => {
        if (e.target.classList.contains("MuiAvatar-img")) {
            setPage(0);
            setRowsDet(rowsDetOG);

            setFilters({
                filtersArray: [
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                    },
                ],
            });
        }
    };

    return (
        <FiltersPopover
            id={id}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            cleanFilters={cleanFilters}
            handleClick={handleClick}
            length={filters.filtersArray.filter((item) => item.type && (item.value || item.since || item.until)).length}
            addFilter={addFilter}
            disabled={filters.filtersArray.length === 2}
        >
            {filters.filtersArray.map((value, index) => (
                <Grid container spacing={2} alignItems="center" key={"convComponent_" + index} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={11}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <BaseSelect2
                                    size="small"
                                    value={value.type}
                                    onChange={(e) => handleChangeType(e, index)}
                                    label={t("filters.attribute")}
                                >
                                    {value.type !== ""
                                        ? attributes
                                              .filter(
                                                  (item) =>
                                                      !filters.filtersArray.map((item) => item.type).includes(item.id)
                                              )
                                              .concat(attributes.filter((item) => item.id === value.type))
                                              .map((item) => (
                                                  <MenuItem value={item.id} key={"attr_" + item.id}>
                                                      {item.name}
                                                  </MenuItem>
                                              ))
                                        : attributes
                                              .filter(
                                                  (item) =>
                                                      !filters.filtersArray.map((item) => item.type).includes(item.id)
                                              )
                                              .map((item) => (
                                                  <MenuItem value={item.id} key={"attr_" + item.id}>
                                                      {item.name}
                                                  </MenuItem>
                                              ))}
                                </BaseSelect2>
                            </Grid>
                            {value.type === "" && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        size="small"
                                        value={value.type}
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeType(e, index)}
                                        values={[]}
                                        disabled
                                    />
                                </Grid>
                            )}
                            {value.type === 1 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        size="small"
                                        label={t("filters.select")}
                                        value={value.value}
                                        onChange={(e) => handleChangeFilter(e, index)}
                                    >
                                        {trans.map((item) => (
                                            <MenuItem value={item.id} key={"trans_" + item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 2 && (
                                <>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.since")}
                                            onChange={(e) => handleChangeFilterRange(e, index, "since")}
                                            value={value.since !== "" ? value.since : null}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.until")}
                                            minDate={
                                                filters.filtersArray[index]?.since !== ""
                                                    ? filters.filtersArray[index].since
                                                    : null
                                            }
                                            onChange={(e) => handleChangeFilterRange(e, index, "until")}
                                            value={value.until !== "" ? value.until : null}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={1} display="flex" justifyContent="center">
                        {filters.filtersArray.length > 1 && (
                            <DeleteIcon
                                color="primary"
                                sx={{ cursor: "pointer" }}
                                onClick={() => removeFilter(index)}
                            />
                        )}
                        {filters.filtersArray.length === 1 &&
                            (value.value !== "" || value.since !== "" || value.until !== "") && (
                                <DeleteIcon
                                    color="primary"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => removeFirstFilter()}
                                />
                            )}
                    </Grid>
                </Grid>
            ))}
        </FiltersPopover>
    );
};

export default FiltersButtonDet;
